import React from 'react';
import ErrorIcon from '@assets/icons/alert-icon.svg';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from '@mui/material';
import 'FielderUtils/style.css';
import { FielderButton } from 'OldComponents/ui';

export default function UpdateDocumentLinkMessage(props) {
  const lan = useLanguage();

  return (
    <Dialog
      id="ErrorMessage-modal"
      open
      onClose={props.handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          className:
            'Fielder-modals-header-border Fielder-modals-content-border shadow-lg',
        },
      }}
    >
      <DialogTitle className="Fielder-modals-create-edit-detail-header-border" />
      <DialogContent className="error-message-modal-body text-center">
        <img src={ErrorIcon} className="error-message-center-icon" alt="" />
        <Box
          id="ErrorMessage-message"
          className="text-center ml-2 mr-2 mt-3 mb-3 error-message-margin"
        >
          {props.message}
        </Box>
        <Grid container spacing={2} sx={{ mt: 1, pl: 3, pr: 3, mb: 1 }}>
          <Grid size={6}>
            <FielderButton
              id="confirm-btn"
              fullWidth
              onClick={props.updateFileConfirm}
            >
              {lan.accept}
            </FielderButton>
          </Grid>
          <Grid size={6}>
            <FielderButton
              outlined
              id="cancel-btn"
              type="button"
              fullWidth
              onClick={props.handleClose}
            >
              {lan.cancel}
            </FielderButton>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
}

//Original code:
/*import React from 'react';
import ErrorIcon from '@assets/icons/alert-icon.svg';
import { useLanguage } from 'Context/LanguageContext';
export default function UpdateDocumentLinkMessage(props) {
	const lan = useLanguage();
	return (
		<>
			<Modal
				id='ErrorMessage-modal'
				size='sm'
				show
				onHide={props.handleClose}
				dialogClassName='shadow-lg'
				className='Fielder-modals-header-border Fielder-modals-content-border shadow-lg'
			>
				<Modal.Header className='Fielder-modals-create-edit-detail-header-border'>
					<Modal.Title />
				</Modal.Header>
				<Modal.Body className='error-message-modal-body text-center'>
					<img src={ErrorIcon} className='error-message-center-icon' alt='' />

					<div id='ErrorMessage-message' className='text-center ml-2 mr-2 mt-3 mb-3 error-message-margin'>
						{props.message}
					</div>

					<div className='row mt-2'>
						<div className='col ml-1'>
							<button
								id='ErrorMessage-btn'
								type='submit'
								className='btn btn-outline-primary btn-success buttonUpdateFileSise error-message-btn-margin'
								onClick={props.updateFileConfirm}
							>
								{lan.accept}
							</button>
						</div>
						<div className='col ml-1'>
							<button
								id='ErrorMessage-btn'
								type='submit'
								className='btn btn-outline-primary btn-success buttonUpdateFileSise error-message-btn-margin'
								onClick={props.handleClose}
							>
								{lan.cancel}
							</button>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer />
			</Modal>
		</>
	);
}
*/
